import { useState } from "react";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { PencilSimpleLine } from "@phosphor-icons/react";

export default function CaptureBox({ onCapture, loading }) {
  const [text, setText] = useState("");

  const submit = async () => {
    const value = text.trim();
    if (!value) return;
    const success = await onCapture(value);
    if (success !== false) setText("");
  };

  return (
    <div className="fixed bottom-6 right-6 z-30 w-[min(92vw,25rem)] rounded-[1rem] border border-[hsl(var(--input))] bg-card px-4 py-3 shadow-[0_1px_0_hsl(var(--border))]">
      <div className="flex items-start gap-3">
        <div className="pt-1 text-[hsl(var(--accent))]">
          <PencilSimpleLine size={16} />
        </div>
        <div className="min-w-0 flex-1">
          <Textarea
            value={text}
            onChange={(event) => setText(event.target.value)}
            placeholder="Tell HomeBase something to remember…"
            className="min-h-[84px] resize-none border-0 px-0 py-0 text-sm leading-6 shadow-none focus-visible:ring-0"
          />
          <div className="mt-3 flex items-center justify-between gap-3">
            <p className="text-xs text-[hsl(var(--muted-foreground))]">Capture first, confirm before it becomes work.</p>
            <Button
              type="button"
              className="rounded-[0.625rem]"
              disabled={loading || !text.trim()}
              onClick={submit}
              data-testid="obligations-capture-submit"
            >
              {loading ? "Capturing…" : "Capture"}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
